import { Factory, Model } from "miragejs";
import { FileUploadResponse } from "./types";
export const FileUploadsFactory = () => {
  return Factory.extend<FileUploadResponse>(
    `https://fuzzys-public-uploads-prod.s3.us-east-2.amazonaws.com/5a1fb952-cfe2-41b6-9728-1ae7e419dd01`
  );
};

export const FileUploadModel = Model.extend<Partial<FileUploadResponse>>("");
